module.exports = __webpack_public_path__ + "static/media/construction.151d58a2.gif";